class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      /* MDL: Dawn asumía que la sección siempre viene y que el elemento destino
         siempre existe. Si cualquiera falta, el TypeError corta el resto del
         renderizado y el botón de agregar al carrito se queda cargando. */
      if (!sectionHTML) return;

      /* MDL: 'targets' permite pintar VARIOS contenedores con un solo fragmento
         (la barra de envío gratis vive a la vez en la PDP y en este popup, y no
         pueden compartir id). Sin esto, getElementById solo actualizaría uno. */
      if (section.targets) {
        const markup = this.getSectionInnerHTML(sectionHTML, section.selector);
        document.querySelectorAll(section.targets).forEach((el) => {
          el.innerHTML = markup;
        });
        return;
      }

      const target = document.getElementById(section.id);
      if (!target) return;
      target.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        /* MDL: barra de progreso hacia envío gratis. product-form.js construye la
           lista de secciones a pedir desde aquí, así que basta con listarla. */
        id: 'mdl-free-shipping',
        targets: '[data-mdl-fs]',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
